<template>
    <a-modal :visible="visible" :title="state.title" @ok="ConversionPoint" @cancel="handleModalCancel" width="70%"
        :destroy-on-close="true" :footer="null">

        <AForm ref="formRef" class="myform" :model="form" :rules="state.rules" @finish="handleOk"
            :wrapper-col="{ span: 14 }" :scroll-to-first-error="true">

            <!-- bulan -->
            <ARow class="form-row">
                <ACol :xl="12" :md="24">
                    <AFormItem label="Pilih Bulan" label-align="left" :label-col="{ md: { span: 8 } }"
                        :wrapper-col="{ md: { span: 24 - 8 } }" required name="bulan" has-feedback>
                        <AMonthPicker v-model:value="form.bulan" :allow-clear="false" placeholder="Pilih Bulan"
                            :disabled-date="disabledDate" format="MMMM YYYY" @change="fetchTargetDay"
                            :disabled="form.readOnly || form.id" style="width:100%;" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- pilih user TSO -->
            <ARow v-if="hasRoles([ROLE_ADMIN_BK, ROLE_TIM_CRM, ROLE_CRM_HELPDESK_CUSTOMER_CARE])" class="form-row">
                <ACol :xl="12" :md="24">
                    <AFormItem label="Pilih User TSO" label-align="left" :label-col="{ md: { span: 8 } }"
                        :wrapper-col="{ md: { span: 24 - 8 } }" name="useram_id" has-feedback>
                        <FilterUsers v-model:value="form.useram_id" :status_mapping="1"
                            :disabled="form.readOnly || !form.bulan" :mode="null" style="width:100%;"
                            placeholder="Pilih User TSO" :join-options="form.useram_id && item.id
                                ? [{ id: form.useram_id, name: item.useram_name }]
                                : []" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- pilih salesman -->
            <ARow class="form-row">
                <ACol :xl="12" :md="24">
                    <AFormItem label="Pilih Salesman" label-align="left" :label-col="{ md: { span: 8 } }"
                        :wrapper-col="{ md: { span: 24 - 8 } }" required name="salesman_id" has-feedback>
                        <FilterATSalesmanSalesman v-model:value="form.salesman_id" :useram_id="form.useram_id"
                            :disabled="form.readOnly || !form.bulan || isLock"
                            @change="() => { fetchTargetCustomer(); fetchByUserList(); }" :mode="null"
                            :class="[isLock ? 'lockInput' : '']" style="width:100%;" :join-options="form.salesman_id
                                ? [{ id: item.salesman_id, nopeg: item.salesman_nopeg, name: item.salesman_name }]
                                : []" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- row child 1 -->
            <ARow class="form-row">
                <ACol :xl="12" :md="24">
                    <AFormItem label="Target Hari Kerja" label-align="left" :label-col="{ md: { span: 8 } }"
                        :wrapper-col="{ md: { span: 24 - 8 } }" required name="target_hari_kerja" has-feedback>
                        <AInput placeholder="number" type="number" :min="0" v-model:value="form.target_hari_kerja"
                            :disabled="isLock" @keydown="handleKeydown" :class="[isLock ? 'lockInput' : '']">
                            <template #suffix>
                                <ATooltip v-if="state.label.target_hari_kerja"
                                    :title="`Target Hari Kerja telah di inputkan oleh ${state.label.user_name} dengan nilai ${getLabelNull(state.label.target_hari_kerja)}`">
                                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                                </ATooltip>
                            </template>
                        </AInput>
                    </AFormItem>
                </ACol>
                <ACol :xl="12" :md="24">
                    <AFormItem label="Target Visit" label-align="left" :label-col="{ md: { span: 8 } }"
                        :wrapper-col="{ md: { span: 24 - 8 } }" required name="target_visit" has-feedback>
                        <AInput placeholder="number" type="number" :min="0" v-model:value="form.target_visit"
                            :disabled="form.readOnly || isLock" :class="[isLock ? 'lockInput' : '']">
                            <template #suffix>
                                <ATooltip v-if="state.label.target_visit"
                                    :title="`Target Visit telah di inputkan oleh ${state.label.user_name} dengan nilai ${getLabelNull(state.label.target_visit)}`">
                                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                                </ATooltip>
                            </template>
                        </AInput>
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- row child 2 -->
            <ARow class="form-row">
                <ACol :xl="12" :md="24">
                    <AFormItem label="Target Coverage" label-align="left" :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }" required name="target_coverage" has-feedback>
                        <AInput placeholder="number" type="number" :min="0" v-model:value="form.target_coverage"
                            :disabled="isLock" @keydown="handleKeydown" :class="[isLock ? 'lockInput' : '']">
                            <template #suffix>
                                <ATooltip v-if="state.label.target_coverage"
                                    :title="`Target Coverage telah di inputkan oleh ${state.label.user_name} dengan nilai ${getLabelNull(state.label.target_coverage)}`">
                                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                                </ATooltip>
                            </template>
                        </AInput>
                    </AFormItem>
                </ACol>
                <ACol :xl="12" :md="24">
                    <AFormItem label="Target Efektif Visit" label-align="left" :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }" name="target_efektif_visit" has-feedback>
                        <AInput placeholder="Otomatis 70% dari Target Visit" type="number" :min="0"
                            v-model:value="form.target_efektif_visit" :disabled="isLock" @keydown="handleKeydown"
                            :class="[isLock ? 'lockInput' : '']">
                            <template #suffix>
                                <ATooltip v-if="state.label.target_efektif_visit"
                                    :title="`Target Efektif Visit telah di inputkan oleh ${state.label.user_name} dengan nilai ${getLabelNull(state.label.target_efektif_visit)}`">
                                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                                </ATooltip>
                            </template>
                        </AInput>
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- row child 3 -->
            <ARow class="form-row">
                <ACol :xl="12" :md="24">
                    <AFormItem label="Target Customer Active" label-align="left" :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }" required name="target_customer_active" has-feedback>
                        <AInputNumber v-model:value="form.target_customer_active" :min="0" placeholder="Masukkan angka"
                            style="width: 100%" :disabled="isLock" @keydown="handleKeydown"
                            :class="[isLock ? 'lockInput' : '']">
                            <template #suffix>
                                <ATooltip v-if="state.label.target_customer_active"
                                    :title="`Target Customer Active telah diinputkan oleh ${state.label.user_name} dengan nilai ${getLabelNull(state.label.target_customer_active)}`">
                                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                                </ATooltip>
                            </template>
                        </AInputNumber>
                    </AFormItem>
                </ACol>
                <ACol :xl="12" :md="24">
                    <AFormItem label="Target Volume" label-align="left" :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }" required name="target_volume" has-feedback>
                        <AInput placeholder="number" type="number" :min="0" v-model:value="form.target_volume"
                            :disabled="form.readOnly">
                            <template #suffix>
                                <ATooltip v-if="state.label.target_volume"
                                    :title="`Target Volume telah di inputkan oleh ${state.label.user_name} dengan nilai ${getLabelNull(state.label.target_volume)}`">
                                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                                </ATooltip>
                            </template>
                        </AInput>
                    </AFormItem>
                </ACol>
            </ARow>

            <ARow class="form-row">
                <ACol :xl="12" :md="24">
                    <AFormItem label="Target New Outlet" label-align="left" :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }" required name="target_new_outlet" has-feedback>
                        <AInput placeholder="number" type="number" :min="0" v-model:value="form.target_new_outlet"
                            :disabled="form.readOnly">
                            <template #suffix>
                                <ATooltip v-if="state.label.target_new_outlet"
                                    :title="`Target New Outlet telah di inputkan oleh ${state.label.user_name} dengan nilai ${getLabelNull(state.label.target_new_outlet)}`">
                                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                                </ATooltip>
                            </template>
                        </AInput>
                    </AFormItem>
                </ACol>
            </ARow>

            <ARow v-if="!form.readOnly" class="form-row" type="flex" justify="end">
                <ACol>
                    <AFormItem>
                        <a-button type="primary" html-type="submit" :loading="form.busy" :disabled="form.busy">{{
                            !form.id ? 'Simpan' : 'Perbarui'
                        }}</a-button>
                    </AFormItem>
                </ACol>
            </ARow>
        </AForm>

        <div v-if="state.errors">
            <ASpace>
                <AAlert v-for="(item, index) in state.errors" type="error" :key="index" :message="item" banner closable
                    @close="state.errors = []" />
            </ASpace>
        </div>
    </a-modal>
</template>
<script>
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
    computed,
    watch,
    h,
} from 'vue'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import FilterATSalesmanSalesman from '@/components/filter/FilterATSalesmanSalesman'
import FilterUsers from '@/components/filter/FilterUsers'
import Form from 'vform'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import moment from 'moment'
import { debounce, pickBy, toNumber } from 'lodash'
import localStorage from 'store'
import {
    ROLE_TSO,
    ROLE_ASM,
    ROLE_ADMIN_BK,
    ROLE_TIM_CRM,
    ROLE_CRM_HELPDESK_CUSTOMER_CARE,
    hasRoles,
} from '@/helpers'
import ARow from 'ant-design-vue/lib/grid/Row'

export default defineComponent({
    components: {
        InfoCircleOutlined,
        FilterATSalesmanSalesman,
        FilterUsers,
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
                readOnly: false,
            }),
        },
    },
    emits: ['update:visible', 'update:item', 'success'],
    setup(props, { emit }) {
        const user = computed(() => localStorage.get('profile'))

        const form = reactive(new Form({
            id: props.item.id,
            bulan: null,
            useram_id: [],
            salesman_id: [],
            target_hari_kerja: null,
            target_visit: null,
            target_efektif_visit: null,
            target_coverage: null,
            target_customer_active: null,
            target_volume: null,
            target_new_outlet: null,
        }))

        const formRef = ref()

        const state = reactive({
            title: 'Lihat Data Target Salesman',
            endpoint: '/api/atsalesman/target',
            endpointGetMinTarget: '/api/atsalesman/target-minimum',
            data: [],
            page: 1,
            per_page: 1,
            total: 0,
            loading: false,
            rules: {
                bulan: [{ required: true, message: 'Bulan tidak boleh kosong!' }],
                salesman_id: [{ required: true, message: 'Salesman tidak boleh kosong!' }],
                target_hari_kerja: [{ required: true, message: 'Target hari kerja tidak boleh kosong!' }],
                target_visit: [{ required: true, message: 'Target visit tidak boleh kosong!' }],
                target_coverage: [{ required: true, message: 'Target coverage tidak boleh kosong!' }],
                target_customer_active: [{ required: true, message: 'Target customer active tidak boleh kosong!' }],
                target_volume: [{ required: true, message: 'Target volume tidak boleh kosong!' }],
                target_new_outlet: [{ required: true, message: 'Target new outlet tidak boleh kosong!' }],
            },
            errors: [],
            label: new Form({
                user_name: '',
                target_hari_kerja: null,
                target_visit: null,
                target_efektif_visit: null,
                target_coverage: null,
                target_customer_active: null,
                target_volume: null,
                target_new_outlet: null,
            }),
        })

        /**
         * Helper: ekstrak nilai numerik dari field SFC.
         *
         * Backend getTargetDays() bisa mengembalikan field dalam 2 bentuk:
         *
         * 1) Angka biasa (jika SFC belum ada → pakai fallback $workdays/$targetVisits)
         *    contoh: { "target_hari_kerja": 25, "target_visit": 150 }
         *
         * 2) Array of {level, value, entitas} (jika SFC ada via getTargetLevelByMonth)
         *    contoh: { "target_hari_kerja": [{level:0,value:25,entitas:null}, ...] }
         *
         * Prioritas ambil nilai: level 0 (global) → level 1 (vendor) → level 2 (salesman) → elemen pertama
         */
        const extractSfcValue = (field) => {
            if (field === null || field === undefined) return null

            // Kalau bukan array → langsung return sebagai angka
            if (!Array.isArray(field)) {
                const num = Number(field)
                return isNaN(num) ? null : num
            }

            // Array of objects → ambil berdasarkan prioritas level
            const byLevel = (lvl) => field.find(
                f => Number(f.level) === lvl && f.value !== null && f.value !== undefined,
            )
            const found = byLevel(0) ?? byLevel(1) ?? byLevel(2) ?? field[0]
            if (!found) return null
            const num = Number(found.value)
            return isNaN(num) ? null : num
        }

        // Watch target_visit → otomatis update efektif visit = round(80%)
        watch(() => form.target_visit, (newVal) => {
            const num = Number(newVal)
            form.target_efektif_visit = (!isNaN(num) && num > 0)
                ? Math.round(num * 0.8)
                : null
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const isLock = computed(() => {

            if (hasRoles([ROLE_ADMIN_BK])) {
                return false
            }

            return form.readOnly ||
                (!!form.id && hasRoles([ROLE_TSO, ROLE_ASM]))
        })

        const handleKeydown = (e) => {
            if (isLock.value) {
                e.preventDefault()
            }
        }

        const disabledDate = current => {
            return current && current < moment().startOf('month')
        }

        const handleOk = async () => {
            await formRef.value.validate().catch(() => { })

            let warningMessages = []
            let isTargetRequired = true

            const isEfektifVisitFilled =
                form.target_efektif_visit &&
                Number(form.target_efektif_visit) > 0

            if (isEfektifVisitFilled) {
                try {
                    const { data } = await form.post(state.endpointGetMinTarget, {
                        bulan: moment(form.bulan).format('YYYY-MM'),
                        salesman_id: form.salesman_id,
                        useram_id: form.useram_id,
                    })

                    if (data?.warning) {
                        warningMessages = Object.values(data.warning)
                        isTargetRequired = data.is_required
                    }
                } catch (error) {
                    const responseData = error.response?.data
                    if (responseData?.errors) state.errors = responseData.errors
                }
            }

            const submitRequest = async () => {
                try {
                    const request = !form.id
                        ? await form.post(state.endpoint)
                        : await form.put(`${state.endpoint}/${form.id}`)

                    message.success(!form.id ? 'Berhasil menyimpan' : 'Berhasil memperbarui')
                    handleModalCancel()
                    emit('success', request.data)
                } catch (error) {
                    const responseData = error.response?.data
                    if (responseData?.errors) state.errors = responseData.errors
                }
            }

            if (warningMessages.length > 0) {
                if (isTargetRequired) {
                    Modal.warning({
                        title: 'Gagal Edit Data Target',
                        content: warningMessages.join(', '),
                    })
                } else {
                    Modal.confirm({
                        title: 'Konfirmasi Edit Data Target',
                        content: warningMessages.join(', '),
                        onOk: submitRequest,
                    })
                }
            } else {
                await submitRequest()
            }
        }

        /**
         * Dipanggil saat bulan berubah.
         * Mengambil data dari SFC dan mengisi:
         *   - target_hari_kerja
         *   - target_visit
         *   - target_new_outlet  (key backend: target_new_outlet atau target_noo)
         *   - target_efektif_visit (otomatis 70% dari target_visit, dibulatkan)
         */
        const fetchTargetDay = () => {
            if (!form.bulan) return

            apiClient
                .get('/api/atsalesman/target-days', {
                    params: pickBy({ month: moment(form.bulan).format('YYYY-MM') }),
                })
                .then(({ data }) => {
                    const sales = data?.sales ?? {}

                    // Uncomment untuk debug struktur response jika masih bermasalah:
                    // console.log('[fetchTargetDay] sales:', JSON.stringify(sales))

                    const visit = extractSfcValue(sales.target_visit)

                    form.target_hari_kerja = extractSfcValue(sales.target_hari_kerja)
                    form.target_visit = visit
                    // backend bisa pakai key "target_new_outlet" atau "target_noo"
                    form.target_new_outlet = extractSfcValue(
                        sales.target_new_outlet !== undefined
                            ? sales.target_new_outlet
                            : sales.target_noo,
                    )
                    // set eksplisit (watcher juga akan trigger karena target_visit berubah)
                    form.target_efektif_visit = visit !== null ? Math.round(visit * 0.7) : null
                })
                .catch((err) => {
                    console.error('[fetchTargetDay] error:', err)
                })
        }

        const fetchTargetCustomer = debounce(() => {
            if (form.id) return

            apiClient
                .get('/api/atsalesman/target-customers', {
                    params: pickBy({
                        month: moment(form.bulan).format('YYYY-MM'),
                        salesman_id: form.salesman_id,
                        useram_id: form.useram_id,
                    }),
                })
                .then(({ data }) => {
                    form.target_coverage = data.sales.target_coverage
                    form.target_customer_active = data.sales.target_customer_active
                })
        }, 50)

        const fetchByUserList = debounce(() => {
            state.label.reset()

            apiClient
                .get('/api/atsalesman/target-tooltips', {
                    params: pickBy({
                        month: moment(form.bulan).format('YYYY-MM'),
                        salesman_id: form.salesman_id,
                        useram_id: form.useram_id,
                    }),
                })
                .then(({ data }) => {
                    if (data.users) {
                        data.users.forEach(u => {
                            state.label.user_name = u.useram_name
                            state.label.target_hari_kerja = u.target_hari_kerja
                            state.label.target_visit = u.target_visit
                            state.label.target_efektif_visit = u.target_efektif_visit
                            state.label.target_coverage = u.target_coverage
                            state.label.target_customer_active = u.target_customer_active
                            state.label.target_volume = u.target_volume
                            state.label.target_new_outlet = u.target_new_outlet
                        })
                    }
                })
        }, 50)

        const getLabelNull = (val) => val || 0

        onMounted(() => {
            if (!form.id) {
                form.reset()
            } else {
                form.bulan = props.item.bulan
                form.salesman_id = props.item.salesman_id
                form.target_hari_kerja = props.item.target_hari_kerja
                form.target_visit = props.item.target_visit
                form.target_efektif_visit = props.item.target_efektif_visit
                form.target_coverage = props.item.target_coverage
                form.target_customer_active = props.item.target_customer_active
                form.target_volume = props.item.target_volume
                form.target_new_outlet = props.item.target_new_outlet
                form.readOnly = props.item.readOnly
                fetchByUserList()
            }

            if (!props.item.readOnly) {
                state.title = `${!form.id ? 'Tambah' : 'Edit'} Data Target Salesman`
            }

            form.useram_id = hasRoles([ROLE_TSO]) ? user.value.id : props.item.useram_id
        })

        return {
            formRef,
            handleOk,
            form,
            state,
            handleModalCancel,
            disabledDate,
            fetchTargetDay,
            fetchTargetCustomer,
            fetchByUserList,
            getLabelNull,
            hasRoles,
            isLock,
            handleKeydown,
            ROLE_ADMIN_BK,
            ROLE_ASM,
            ROLE_TSO,
            ROLE_TIM_CRM,
            ROLE_CRM_HELPDESK_CUSTOMER_CARE,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';

:deep(.lockInput) {
    cursor: not-allowed !important;
}
</style>